import _ from 'lodash';
import React from 'react';
import Dropdown from './Dropdown';

const options = _.times(24)
  .reduce(
    (memo, val, i) => {
      const hour = _.padStart(i, 2, '0');
      memo.push(`${hour}:00`);
      memo.push(`${hour}:15`);
      memo.push(`${hour}:30`);
      memo.push(`${hour}:45`);
      if (hour === '23') {
        memo.push('24:00');
      }
      return memo;
    },
    []
  )
  .map(time => ({
    label: time,
    value: time
  }));

function TimeDropdown(props) {
  return <Dropdown {...props} options={options} />;
}

export default TimeDropdown;



// WEBPACK FOOTER //
// ./src/commons/components/TimeDropdown.jsx